export const EDUCATION_LEVEL_OPTIONS = [
  { value: "Less than high school", label: "Less than high school" },
  { value: "Some high school, no diploma", label: "Some high school, no diploma" },
  { value: "High school diploma or GED", label: "High school diploma or GED" },
  { value: "Some college, no degree", label: "Some college, no degree" },
  { value: "Trade/Vocational Certificate", label: "Trade/Vocational Certificate" },
  { value: "Associate degree", label: "Associate degree" },
  { value: "Bachelor's degree", label: "Bachelor's degree" },
  { value: "Master's degree", label: "Master's degree" },
  { value: "Doctorate or professional degree", label: "Doctorate or professional degree" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const HEAR_ABOUT_US_OPTIONS = [
  { value: "School counselor or teacher", label: "School counselor or teacher" },
  { value: "Friend or family referral", label: "Friend or family referral" },
  { value: "Current or former participant", label: "Current or former participant" },
  { value: "Social media (Facebook, Instagram, etc.)", label: "Social media (Facebook, Instagram, etc.)" },
  { value: "Website / online search", label: "Website / online search" },
  { value: "Community event", label: "Community event" },
  { value: "Church or place of worship", label: "Church or place of worship" },
  { value: "Flyer or mailer", label: "Flyer or mailer" },
  { value: "Local news or press", label: "Local news or press" },
  { value: "Other (please specify)", label: "Other (please specify)" },
];

export const HEAR_ABOUT_US_OTHER_VALUE = "Other (please specify)";

const EDUCATION_VALUES = new Set(EDUCATION_LEVEL_OPTIONS.map((o) => o.value));
const HEAR_ABOUT_VALUES = new Set(HEAR_ABOUT_US_OPTIONS.map((o) => o.value));

export function mapEducationLevelValue(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "";
  return EDUCATION_VALUES.has(s) ? s : "";
}

export function mapHearAboutUsValue(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "";
  return HEAR_ABOUT_VALUES.has(s) ? s : "";
}

export function getEducationLevelLabel(raw) {
  const v = mapEducationLevelValue(raw);
  if (!v) return "—";
  const opt = EDUCATION_LEVEL_OPTIONS.find((o) => o.value === v);
  return opt ? opt.label : v;
}

export function getHearAboutUsDisplayLabel(hearAboutRaw, otherRaw) {
  const v = mapHearAboutUsValue(hearAboutRaw);
  if (!v) return "—";
  if (v === HEAR_ABOUT_US_OTHER_VALUE) {
    const other = otherRaw != null ? String(otherRaw).trim() : "";
    return other || v;
  }
  return v;
}

/** US ZIP: 12345 or 12345-6789 */
export function validateOptionalUsZip(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "";
  if (/^\d{5}(-\d{4})?$/.test(s)) return "";
  return "Zip code must be 5 digits or 5+4 (e.g. 12345 or 12345-6789).";
}

export function validateRequiredUsZip(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "Zip code is required.";
  if (/^\d{5}(-\d{4})?$/.test(s)) return "";
  return "Zip code must be 5 digits or 5+4 (e.g. 12345 or 12345-6789).";
}

export function validateOptionalEducationLevel(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "";
  if (!EDUCATION_VALUES.has(s)) return "Please select a valid education level option.";
  return "";
}

export function validateRequiredEducationLevel(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "Highest education level is required.";
  if (!EDUCATION_VALUES.has(s)) return "Please select a valid education level option.";
  return "";
}

export function validateOptionalHearAboutUs(hearAboutRaw, otherRaw) {
  const s = hearAboutRaw != null ? String(hearAboutRaw).trim() : "";
  if (!s) return "";
  if (!HEAR_ABOUT_VALUES.has(s)) return "Please select a valid option.";
  if (s === HEAR_ABOUT_US_OTHER_VALUE) {
    const other = otherRaw != null ? String(otherRaw).trim() : "";
    if (!other) return "Please specify how you heard about us.";
  }
  return "";
}

export function validateRequiredHearAboutUs(hearAboutRaw, otherRaw) {
  const s = hearAboutRaw != null ? String(hearAboutRaw).trim() : "";
  if (!s) return "How did you hear about us is required.";
  if (!HEAR_ABOUT_VALUES.has(s)) return "Please select a valid option.";
  if (s === HEAR_ABOUT_US_OTHER_VALUE) {
    const other = otherRaw != null ? String(otherRaw).trim() : "";
    if (!other) return "Please specify how you heard about us.";
  }
  return "";
}
